module.exports = __webpack_public_path__ + "klue-salesforce-button-14ddc91081eb9b62c229adb00f1f4484.svg";